import logo from './logo.svg';
import './App.scss';
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WebMaintenance from './pages/web_maintenance';
import StaffLogin from './pages/stafflogin';
import CreateStaffUser from './pages/staff/createstaffuser';
import ProtectedRoute from './components/Login/ProtectedRoute';
import { jwtDecode } from 'jwt-decode';
import CIS from './pages/cis';
import ChangeStaffUserPW from './pages/staff/changestaffuserpw';
import NotFound from './pages/not_found';
import Infrastructure from './pages/infrastructure';
import GISCustomers from './pages/gis_customers';
import DataPage from './pages/data';
import Customers from './pages/customers';
import LineBAccounts from './pages/LineBAccounts';
import LineBAccountDetail from './pages/LineBAccountDetail';
import Incidences from './pages/incidences';
import ReportIncident from './pages/ReportIncident';
import NRW from './pages/nrw';
import MeterUpdation from './pages/meter_updation';

function App() {

  const [role, setRole] = useState();

  useEffect(() => {
    const token = localStorage.getItem("nimda_giwasco");

    if (token) {
      var decoded = jwtDecode(token);
      setRole(decoded.Role);
    } else {
      setRole();
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route exact path = "/" element = {<GISCustomers />}/>
        <Route exact path = "/giscustomers" element = {<GISCustomers/>}/>
        <Route exact path = "/infrastructure" element = {<Infrastructure/>}/>
        <Route exact path = "/customers" element = {<MeterUpdation/>}/>
        <Route exact path = "/nrw" element = {<NRW/>}/>
        <Route exact path = "/cis" element = {<CIS/>}/>
        <Route exact path = "/incidences" element = {<Incidences/>}/>
        <Route exact path = "/incidences/report" element = {<ReportIncident/>}/>
        <Route exact path = "/data" element = {<DataPage/>}/>
        <Route exact path = "/stafflogin" element = {<StaffLogin />}/>
        <Route exact path = "/admin/create" element = {<CreateStaffUser />}/>
        <Route exact path = "/admin/changepass" element = {<ProtectedRoute component={ChangeStaffUserPW} />}/>
        <Route exact path = "/linebaccounts" element = {<LineBAccounts />}/>
        <Route exact path="/linebaccounts/:account" element={<LineBAccountDetail />} />

        <Route exact path='/*' element = {<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
